export default "__VITE_ASSET__BU57QLdY__"